class ProductPairWith extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.ctaButton = null;
    this.finalTotalEl = null;
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.product_pair_with_grid'));
    this.ctaButton = this.querySelector('.js-pair-with-cta');
    this.finalTotalEl = this.querySelector('.js-final-total');

    this.bindEvents();
    this.updateFinalTotal();
  }

  bindEvents() {
    this.items.forEach(item => {
      const checkbox = item.querySelector('.product_pair_checkbox');
      const select = item.querySelector('.js-variant-select');

      checkbox.addEventListener('change', () => this.updateFinalTotal());
      select.addEventListener('change', (e) => this.onVariantChange(e, item));
    });

    this.ctaButton.addEventListener('click', () => this.addToCart());
  }

  onVariantChange(event, item) {
    const select = event.currentTarget;
    const selectedOption = select.options[select.selectedIndex];
    const newVariantId = selectedOption.value;
    const newPrice = selectedOption.dataset.price;

    const checkbox = item.querySelector('.product_pair_checkbox');
    const priceEl = item.querySelector('.js-product-price');

    // update checkbox value (important)
    checkbox.value = newVariantId;
    checkbox.dataset.price = newPrice;

    // update UI price
    priceEl.innerHTML = newPrice;

    this.updateFinalTotal();
  }

  updateFinalTotal() {
    let total = 0;

    this.items.forEach(item => {
      const checkbox = item.querySelector('.product_pair_checkbox');
      if (checkbox.checked) {
        let priceInFloat = checkbox.dataset.price;
        total += this.parseCurrency(priceInFloat);
      }
    });

    this.finalTotalEl.innerHTML = this.formatPrice(total);
  }

  parseCurrency(str) {
    if (!str) return 0;

    // Step 1: Remove currency symbols and spaces
    str = str.replace(/[^\d.,]/g, "");

    // Step 2: Determine last separator as decimal
    let lastDot = str.lastIndexOf(".");
    let lastComma = str.lastIndexOf(",");

    let decimalSeparator = "";
    if (lastDot > lastComma) decimalSeparator = ".";
    else if (lastComma > lastDot) decimalSeparator = ",";
    
    // Step 3: Remove all other separators
    if (decimalSeparator === ".") str = str.replace(/,/g, "");
    else if (decimalSeparator === ",") str = str.replace(/\./g, "").replace(",", ".");

    // Step 4: Convert to float
    let num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  }

  formatPrice(input, formatString) {
    // Step 1: Normalize the input number
    let num = typeof input === 'string' ? parseFloat(input.replace(',', '.')) : input;
    if (isNaN(num)) return '';

    // Step 2: Use passed formatString or fallback to DOM
    if (!formatString) {
      let el = this.querySelector('.product_pair_checkbox');
      if (el) formatString = el.dataset.price;
      else return num.toFixed(2);
    }

    // Step 3: Extract currency symbol and style
    const match = formatString.match(/([^0-9.,]*)([\d.,]+)([^0-9.,]*)/);
    if (!match) return num.toFixed(2);

    const prefix = match[1]; // e.g. "$", "Tk ", "€"
    const originalNumber = match[2]; // e.g. "1,234.56" or "1.234,56"
    const suffix = match[3]; // e.g. "", " BDT", etc.

    // Step 4: Detect separator style
    const useCommaAsDecimal = originalNumber.includes(',') && originalNumber.indexOf(',') > originalNumber.indexOf('.');
    const decimalSeparator = useCommaAsDecimal ? ',' : '.';
    const thousandSeparator = useCommaAsDecimal ? '.' : ',';

    // Step 5: Format number with 2 decimals and thousands separator
    const parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator); // Add thousands sep
    const final = parts.join(decimalSeparator); // Add decimal sep

    // Step 6: Return combined
    return `${prefix}${final}${suffix}`;
  }

  addToCart() {
    this.ctaButton.querySelector('.loading-overlay').classList.remove('loader-hidden');
    const itemsToAdd = [];

    this.items.forEach(item => {
      const checkbox = item.querySelector('.product_pair_checkbox');

      if (checkbox.checked) {
        itemsToAdd.push({
          id: checkbox.value,
          quantity: 1
        });
      }
    });

    if (!itemsToAdd.length) {
      alert('Please select at least one product.');
      this.ctaButton.querySelector('.loading-overlay').classList.add('loader-hidden');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(res => res.json())
    .then(data => {
      console.log('Added to cart:', data);
      this.ctaButton.querySelector('.loading-overlay').classList.add('loader-hidden');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => {
        document.querySelector('.header__cart-link a[aria-controls="cart-drawer"]').click();
      }, 500);
    })
    .catch(err => console.error('Cart Error:', err));
  }
}

if (!customElements.get('product-pair-with')) {
  customElements.define('product-pair-with', ProductPairWith);
}
